import { Delivery } from '@/config/types/Routes';

export interface ShipmentFromDeletedRoutesType  extends Delivery {
    routeId: number;
};

export enum ItemTypes {
    SHIPMENT = 'shipment'
};